// Services.jsx
import React from "react";
import "./Services.css";

const Services = () => {
  const services = [
    {
      id: 1,
      title: "Wedding Decoration",
      description: "Make your wedding day magical with beautiful floral arrangements, lighting, and elegant decor setups.",
      image: "https://images.unsplash.com/photo-1511795409834-ef04bbd61622?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80"
    },
    {
      id: 2,
      title: "Home Decoration",
      description: "Transform your home for special occasions with stunning decorations that create a warm and festive atmosphere.",
      image: "https://images.unsplash.com/photo-1586023492125-27b2c045efd7?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80"
    },
    {
      id: 3,
      title: "Haldi Decoration",
      description: "Bright and colorful Haldi setups with traditional elements, flowers, and vibrant decor for this special ceremony.",
      image: "https://images.unsplash.com/photo-1600950209144-c39c47fd5c9b?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80"
    },
    {
      id: 4,
      title: "Mehndi Decoration",
      description: "Beautiful Mehndi setups with colorful fabrics, flowers, and traditional Indian decor elements.",
      image: "https://images.unsplash.com/photo-1591280063444-d3f1b3a5b4c0?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80"
    },
    {
      id: 5,
      title: "Bride Entry Decoration",
      description: "Create a grand entrance for the bride with beautiful floral canopies, petals, and stunning decor.",
      image: "https://images.unsplash.com/photo-1583939003579-730e3918a45a?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80"
    },
    {
      id: 6,
      title: "Groom Entry Decoration",
      description: "Make the groom's entry memorable with impressive decor, lights, and traditional elements.",
      image: "https://images.unsplash.com/photo-1519741497674-611481863552?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80"
    },
    {
      id: 7,
      title: "Flower Decoration",
      description: "Fresh and artificial flower arrangements for all occasions, from simple bouquets to grand floral setups.",
      image: "https://images.unsplash.com/photo-1532372320572-cda25653a26d?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80"
    },
    {
      id: 8,
      title: "Balloon Decoration",
      description: "Colorful balloon decorations for birthdays, parties, and special events that bring joy and excitement.",
      image: "https://images.unsplash.com/photo-1530103862676-de8c9debad1d?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80"
    },
    {
      id: 9,
      title: "Small Party Decoration",
      description: "Perfect decorations for intimate gatherings, small parties, and private celebrations.",
      image: "https://images.unsplash.com/photo-1528605248644-14dd04022da1?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80"
    },
    {
      id: 10,
      title: "Birthday Decoration",
      description: "Make birthdays special with themed decorations, balloons, banners, and personalized setups.",
      image: "https://images.unsplash.com/photo-1558636508-e0db3814bd1d?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80"
    },
    {
      id: 11,
      title: "Anniversary Decoration",
      description: "Celebrate love with romantic decorations, flowers, candles, and elegant setups for anniversary parties.",
      image: "https://images.unsplash.com/photo-1511795409834-ef04bbd61622?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80"
    },
    {
      id: 12,
      title: "Corporate Event Decoration",
      description: "Professional decorations for corporate events, conferences, product launches, and business gatherings.",
      image: "https://images.unsplash.com/photo-1511578314322-379afb476865?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80"
    },
    {
      id: 13,
      title: "Baby Shower Decoration",
      description: "Adorable baby shower decorations with cute themes, pastel colors, and special elements for the mom-to-be.",
      image: "https://images.unsplash.com/photo-1519340241574-2cec6aef0c01?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80"
    },
    {
      id: 14,
      title: "Engagement Decoration",
      description: "Beautiful engagement ceremony decorations with flowers, lights, and elegant traditional setups.",
      image: "https://images.unsplash.com/photo-1511795409834-ef04bbd61622?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80"
    },
    {
      id: 15,
      title: "Stage Decoration",
      description: "Professional stage decorations for events, weddings, and functions with stunning backdrops and lighting.",
      image: "https://images.unsplash.com/photo-1492684223066-81342ee5ff30?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80"
    }
  ];

  return (
    <section className="services" id="services">
      <div className="services-container">
        {/* Section Header - Centered */}
        <div className="services-header">
          <span className="services-tag">Our Services</span>
          <h2 className="services-title">
            What We <span>Offer</span>
          </h2>
          <p className="services-subtitle">
            From weddings to corporate events, we provide complete decoration solutions 
            for every occasion. Choose from our wide range of services.
          </p>
        </div>

        {/* Services Grid */}
        <div className="services-grid">
          {services.map((service) => (
            <div className="service-card" key={service.id}>
              <div className="service-image-wrapper">
                <img 
                  src={service.image} 
                  alt={service.title} 
                  className="service-image"
                  loading="lazy"
                />
                <div className="service-image-overlay"></div>
              </div>
              <div className="service-content">
                <h3 className="service-title">{service.title}</h3>
                <p className="service-description">{service.description}</p>
                <a href="tel:7023332099" className="service-btn">
                  <i className="fas fa-phone"></i> Book Now
                </a>
              </div>
            </div>
          ))}
        </div>

        {/* CTA Banner */}
        <div className="services-cta">
          <div className="cta-content">
            <h3>Need Custom Decoration?</h3>
            <p>Tell us your requirements and we'll create a personalized decoration plan for your event.</p>
          </div>
          <a href="tel:7023332099" className="cta-btn">
            <i className="fas fa-phone"></i> Call Now
          </a>
        </div>
      </div>
    </section>
  );
};

export default Services;